export default "__VITE_ASSET__Bjy1CmOM__"